import { render, staticRenderFns } from "./TonneExplanation.vue?vue&type=template&id=0bb56667&scoped=true&"
import script from "./TonneExplanation.vue?vue&type=script&lang=ts&"
export * from "./TonneExplanation.vue?vue&type=script&lang=ts&"
import style0 from "./TonneExplanation.vue?vue&type=style&index=0&id=0bb56667&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb56667",
  null
  
)

export default component.exports